import { trackError } from '../appError';
import { isOptionInstrumentString, parseInstrument } from '../instrumentUtils';
import type {
    ICellRendererFunc,
    ICellRendererParams,
    ValueFormatterFunc,
    ValueFormatterParams,
} from '@ag-grid-community/core';
import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';
import type { OptionInstrument } from '@thinkalpha/ui-types/types/instrument';

export const instrumentRenderer: ICellRendererFunc<Instrument> & ValueFormatterFunc<Instrument> = (
    params: ICellRendererParams<Instrument> | ValueFormatterParams<Instrument>,
) => {
    if (!params.value) return '';
    if (!isOptionInstrumentString(params.value)) return params.value;

    try {
        const parsed = parseInstrument(params.value) as OptionInstrument;
        return `${parsed.underlyingInstrument.symbol} | ${parsed.expiry.toString()} | ${parsed.right === 'call' ? 'Call' : 'Put'} | $${parsed.strike}`;
    } catch (e) {
        // Do not throw if instrument is invalid - display original value
        if (e instanceof Error) {
            trackError(e, {
                extra: {
                    instrument: params.value,
                },
            });
        }
    }
    return String(params.value);
};
